import React from 'react'
import { Link, useNavigate } from "react-router-dom";
import {useDispatch} from 'react-redux'

import { sidebarAction } from "../../store/reducers/sidebarSlice"
import { isLoginAction } from '../../store/reducers/isOpenSlice'
const UserProfile = () => {
  const dispatch = useDispatch()
  
  return (
    <Link key='1' to='contact-us' onClick={()=> dispatch(sidebarAction(false))}
    className="!text-white hover:!text-white text-2xl font-bold"
   
  >
    <span>
      <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="w-[25px] h-15 mx-auto"
  >
    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
    <path d="M22 6l-10 7L2 6" />
  </svg>
    </span>
  </Link>
  )
}

export default UserProfile